var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "compliance-questionnaire" }, [
    _c("fieldset", { staticClass: "info-group" }, [
      _c("legend", [
        _vm._v(_vm._s(_vm.$t("kyc.section.complianceQuestionnaire"))),
      ]),
    ]),
    _c(
      "fieldset",
      { attrs: { disabled: _vm.kycStatus === "submitted" ? true : false } },
      [
        _c("p", { staticClass: "questionnaire-s" }, [
          _vm._v(_vm._s(_vm.$t("kyc.q1SanctionsList"))),
        ]),
        _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.question1Status,
                valid: _vm.question1Status,
              },
            },
            [
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("vuestic-kyc-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    ref: "myInput",
                    attrs: {
                      name: "question1",
                      "data-vv-as": "question1",
                      required: "",
                      label: _vm.$t("ticket.select"),
                      "option-key": "value",
                      options: _vm.commonOptions,
                      autocomplete: "off",
                      disabled: _vm.kycStatus === "submitted" ? true : false,
                    },
                    on: {
                      input: (val) => {
                        _vm.question1Status = !val ? true : false
                      },
                    },
                    model: {
                      value: _vm.complianceQuestionnaire.question1,
                      callback: function ($$v) {
                        _vm.$set(_vm.complianceQuestionnaire, "question1", $$v)
                      },
                      expression: "complianceQuestionnaire.question1",
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", { staticClass: "fa icon-right input-icon" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.question1Status,
                          expression: "question1Status",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.$t("kyc.theFieldIsRequired")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "info-group-space" }),
          _c("div", { staticClass: "form-group with-icon-right" }),
        ]),
        _c("p", { staticClass: "questionnaire-s" }, [
          _vm._v("\n    " + _vm._s(_vm.$t("kyc.q2CountryWideSanctions"))),
        ]),
        _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.question2Status,
                valid: _vm.question2Status,
              },
            },
            [
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("vuestic-kyc-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    ref: "myInput",
                    attrs: {
                      name: "question2",
                      "data-vv-as": "question2",
                      required: "",
                      label: _vm.$t("ticket.select"),
                      "option-key": "value",
                      options: _vm.commonOptions,
                      autocomplete: "off",
                      disabled: _vm.kycStatus === "submitted" ? true : false,
                    },
                    on: {
                      input: (val) => {
                        _vm.question2Status = !val ? true : false
                      },
                    },
                    model: {
                      value: _vm.complianceQuestionnaire.question2,
                      callback: function ($$v) {
                        _vm.$set(_vm.complianceQuestionnaire, "question2", $$v)
                      },
                      expression: "complianceQuestionnaire.question2",
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", { staticClass: "fa icon-right input-icon" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.question2Status,
                          expression: "question2Status",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.$t("kyc.theFieldIsRequired")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "info-group-space" }),
          _c("div", { staticClass: "form-group with-icon-right" }),
        ]),
        _c("p", { staticClass: "questionnaire-s" }, [
          _vm._v(_vm._s(_vm.$t("kyc.q3OwnedBySanctioned"))),
        ]),
        _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.question3Status,
                valid: _vm.question3Status,
              },
            },
            [
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("vuestic-kyc-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    ref: "myInput",
                    attrs: {
                      id: "question3Input",
                      name: "question3",
                      "data-vv-as": "question3",
                      required: "",
                      label: _vm.$t("ticket.select"),
                      "option-key": "value",
                      options: _vm.commonOptions,
                      autocomplete: "off",
                      disabled: _vm.kycStatus === "submitted" ? true : false,
                    },
                    on: {
                      input: (val) => {
                        _vm.question3Status = !val ? true : false
                      },
                    },
                    model: {
                      value: _vm.complianceQuestionnaire.question3,
                      callback: function ($$v) {
                        _vm.$set(_vm.complianceQuestionnaire, "question3", $$v)
                      },
                      expression: "complianceQuestionnaire.question3",
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", { staticClass: "fa icon-right input-icon" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.question3Status,
                          expression: "question3Status",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.$t("kyc.theFieldIsRequired")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "info-group-space" }),
          _c("div", { staticClass: "form-group with-icon-right" }),
        ]),
        _c("p", { staticClass: "questionnaire-s" }, [
          _vm._v(
            _vm._s(
              _vm
                .$t("kyc.q4BusinessDealings")
                .replace("{name}", _vm.VUE_APP_NAME)
            )
          ),
        ]),
        _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.question4Status,
                valid: _vm.question4Status,
              },
            },
            [
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("vuestic-kyc-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    ref: "myInput",
                    attrs: {
                      id: "question4Input",
                      name: "question4",
                      "data-vv-as": "question4",
                      required: "",
                      label: _vm.$t("ticket.select"),
                      "option-key": "value",
                      options: _vm.commonOptions,
                      autocomplete: "off",
                      disabled: _vm.kycStatus === "submitted" ? true : false,
                    },
                    on: {
                      input: (val) => {
                        _vm.question4Status = !val ? true : false
                      },
                    },
                    model: {
                      value: _vm.complianceQuestionnaire.question4,
                      callback: function ($$v) {
                        _vm.$set(_vm.complianceQuestionnaire, "question4", $$v)
                      },
                      expression: "complianceQuestionnaire.question4",
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", { staticClass: "fa icon-right input-icon" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.question4Status,
                          expression: "question4Status",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.$t("kyc.theFieldIsRequired")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "info-group-space" }),
          _c("div", { staticClass: "form-group with-icon-right" }),
        ]),
        _c("p", { staticClass: "questionnaire-s" }, [
          _vm._v(_vm._s(_vm.$t("kyc.q1SanctionsList"))),
        ]),
        _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.question5Status,
                valid: _vm.question5Status,
              },
            },
            [
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("vuestic-kyc-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    ref: "myInput",
                    attrs: {
                      id: "question5Input",
                      name: "question5",
                      "data-vv-as": "question5",
                      required: "",
                      label: _vm.$t("ticket.select"),
                      "option-key": "value",
                      options: _vm.commonOptions,
                      autocomplete: "off",
                      disabled: _vm.kycStatus === "submitted" ? true : false,
                    },
                    on: {
                      input: (val) => {
                        _vm.question5Status = !val ? true : false
                      },
                    },
                    model: {
                      value: _vm.complianceQuestionnaire.question5,
                      callback: function ($$v) {
                        _vm.$set(_vm.complianceQuestionnaire, "question5", $$v)
                      },
                      expression: "complianceQuestionnaire.question5",
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", { staticClass: "fa icon-right input-icon" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.question5Status,
                          expression: "question5Status",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.$t("kyc.theFieldIsRequired")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "info-group-space" }),
          _c("div", { staticClass: "form-group with-icon-right" }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }